<template>
  <div class="urgent-box">
    <app-header title="急需续费" @goback="goBack">
      <div slot="tips">
        <div class="header-right" @click="() => {this.isShowCheck = true}" v-if="!isShowCheck">续费</div>
        <div class="header-right" @click="() => {this.isShowCheck = false}" v-else>取消</div>
      </div>
    </app-header>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="urgent-list" ref="urgentList">
        <li v-for="(item, index) in urgentList" :key="index" @click="check(item, index)">
          <checkbox disabled v-model="checkedIds" class="list-checkbox" :value="item.id" v-show="isShowCheck" ref="checkbox"></checkbox>
          <div class="urgent-right">
            <div class="urgent-top">
              <div class="urgent-name">{{ item.productType === 1 ? item.deptName : item.deviceName }}</div>
              <div class="urgent-module">{{ item.productName }}</div>
              <div class="urgent-time">剩余时间：<span>{{`${caclLastTime(item.expireTime)}`}}</span></div>
            </div>
          </div>
        </li>
      </ul>
    </pull-to>
    <Button class="submit-btn" @click="renew" v-show="isShowCheck">提交续费</Button>
    <renew-urgent-modal @confirm="confirmRenew" :select-list="selectList"></renew-urgent-modal>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import { Checkbox } from 'vue-checkbox-radio';
import PullTo from 'vue-pull-to';
import moment from 'moment';
import apis from 'api/index';
import renewUrgentModal from 'components/renew-month-modal.vue';

export default {
  mixins: [commonMixin],
  components: {
    Checkbox,
    PullTo,
    renewUrgentModal
  },
  data() {
    return {
      urgentList: [],
      urgentTotal: 0,
      checkedIds: [],
      pageNumber: 1,
      pageSize: 10,
      isShowCheck: false,
    }
  },
  computed: {
    isLoadAll() {
      return Boolean(this.urgentTotal > this.pageNumber * this.pageSize);
    },
    selectList() {
      return this.urgentList.filter(item => {
        for(let i = 0; i < this.checkedIds.length; i++) {
          if(item.id === this.checkedIds[i]) {
            return item
          }
        }
      });
    },
  },
  created() {
    this.fetchUrgentList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 点击行选中
    check(item, index) {
      if(!this.isShowCheck) return false;
      this.$refs.checkbox[index].toggle(item.id);
    },
    showCheck() {
      this.isShowCheck = true;
    },
    caclLastTime(expireTime) {
      let duration = moment(expireTime).valueOf() - moment().valueOf();
      console.log(duration)
      let afterDays = parseInt(moment.duration(duration).asDays());
      if(duration <= 0) {
        return '已过期';
      } else {
        return `${afterDays}天`;
      }
    },
    renew() {
      if(this.checkedIds.length === 0) {
        this.showToast('请选择再续费', 'error');
        return false;
      }
      this.$modal.show('renew-urgent-modal');
    },
    async confirmRenew(month, price) {
      if(month == null || isNaN(month) || month === 0) {
        this.showToast('请填写月份', 'error');
        return false;
      }
      try {
        let params = {
          ids: this.checkedIds,
          duration: month,
          totalPrice: price
        };
        const res = await apis.usedRenew(JSON.stringify(params));
        this.$modal.hide('renew-urgent-modal');
        this.showToast('续费成功', 'correct');
        this.pageNumber = 1;
        this.fetchUrgentList();
      } catch(err) {
        this.showToast('续费失败', 'error');
        console.error(err);
      }
    },
    loadmore(loaded) {
      if(this.urgentTotal <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchUrgentList().then(res => {
        loaded('done');
      });
    },
    async fetchUrgentList() {
      try {
        let params = {
          no: this.pageNumber,
          limit: this.pageSize,
        };
        const res = await apis.getUrgentList(params);
        if(res != null ) {
          this.urgentList = res.records;
          this.urgentTotal = res.total;
        }
      } catch(err) {
        console.error(err);
      }
    }
  },
  watch: {
    isShowCheck(nVal) {
      nVal ? this.$refs.urgentList.style.marginBottom = '60px' : this.$refs.urgentList.style.marginBottom = '0';
    }
  }
}
</script>

<style src="./bill.scss" lang="scss" scoped></style>
